export const environment = {
  environmentName: 'prod',
  production: true,
  firebaseConfig: {
    apiKey: 'AIzaSyCej-TFQABxXYSu6whpViLknbbKJTMosfM',
    authDomain: 'cadmus-ac9ea.firebaseapp.com',
    projectId: 'cadmus-ac9ea',
    storageBucket: 'cadmus-ac9ea.firebasestorage.app',
    messagingSenderId: '254950457618',
    appId: '1:254950457618:web:1cca78a62521b84ccdf3cb',
  },
  useEmulators: false,
  version: 'v1.5.6',

  functionsLinks: {
    pdfEndpoint: 'https://generatepdf-e6kwemzl7a-ey.a.run.app',
    voucherEndpoint: 'https://generatevoucher-e6kwemzl7a-ey.a.run.app',
    emailEndpoint: 'https://sendemail-e6kwemzl7a-ey.a.run.app',
  },
};
